import { render, staticRenderFns } from "./StarFilled.vue?vue&type=template&id=2b7108b1&"
import script from "./StarFilled.vue?vue&type=script&setup=true&lang=js&"
export * from "./StarFilled.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports